const dataManagetable = r => require.ensure([], () => r(require('../../views/cusPage/DataManage/dataManage.vue')), 'dataManagetable')
const InformationPublish = r => require.ensure([], () => r(require('../../views/cusPage/InformationPublish/InformationPublish.vue')), 'InformationPublish')
const CusPageBannerManage = r => require.ensure([], () => r(require('../../views/cusPage/CusPageBannerManage/CusPageBannerManage.vue')), 'CusPageBannerManage')
const CusPageComplianceManage = r => require.ensure([], () => r(require('../../views/cusPage/CusPageComplianceManage/CusPageComplianceManage.vue')), 'CusPageComplianceManage')
const dataManageclass = r => require.ensure([], () => r(require('../../views/cusPage/DataManageClass/DataManageClass.vue')), 'dataManageclass')
const FAQ = r => require.ensure([], () => r(require('../../views/cusPage/FAQ/FAQ.vue')), 'FAQ')
const cusPageChildrenRouter = [
    {
        path: '/CusPage/DataManage',
        name: 'dataManagetable',
        component: dataManagetable,
        meta: {
            typePage: 2
        }
    },
    {
        path: '/CusPage/InformationPublish',
        name: 'InformationPublish',
        component: InformationPublish,
        meta: {
            typePage: 2
        }
    },
    {
        path: '/CusPage/BannerManage',
        name: 'CusPageBannerManage',
        component: CusPageBannerManage,
        meta: {
            typePage: 2
        }
    },{
        path: '/CusPage/ComplianceManage',
        name: 'CusPageComplianceManage',
        component: CusPageComplianceManage,
        meta: {
            typePage: 2
        }
    },{
        path: '/CusPage/DataManageClass',
        name: 'dataManageclass',
        component: dataManageclass,
        meta: {
            typePage: 2
        }
    },{
        path: '/CusPage/FAQ',
        name: 'FAQ',
        component: FAQ,
        meta: {
            typePage: 2
        }
    }
];
export default cusPageChildrenRouter
